import {grayColor} from '../../cmsMainStyle'

const transferGroupListStyle = theme => ({
	cardHeader: {
		padding: theme.spacing(1, 2),
	},

	list: {
		height: 500,
		overflow: "auto"
	},

	button: {
		margin: theme.spacing(0.5, 0)
	},

	searchBar:{
		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(2)
	},

	search: {
		position: "relative",
		borderRadius: theme.shape.borderRadius,
		backgroundColor: grayColor[1],
		"&:hover": {
		backgroundColor: grayColor[2]
		},
		marginRight: theme.spacing(2),
		marginLeft: 0,
		width: "100%",
		[theme.breakpoints.up("sm")]: {
		marginLeft: theme.spacing(3),
		width: "auto"
		}
	},

	searchIcon: {
		padding: theme.spacing(0, 2),
		height: "100%",
		position: "absolute",
		pointerEvents: "none",
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	},

	inputRoot: {
		color: "inherit"
	},

	inputInput: {
		padding: theme.spacing(1, 1, 1, 0),
		// vertical padding + font size from searchIcon
		paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
		transition: theme.transitions.create("width"),
		width: "100%",
		[theme.breakpoints.up("md")]: {
		width: "100ch"
		}
	},

	nested: {
		paddingLeft: theme.spacing(5),
	},

	externalUserMsg: {
		color: "red"
	}
})

export {transferGroupListStyle}